export default [
    {
        path: '/',
        redirect: '/b2b/home/index'
    },
    {
        path: '/b2b/common/refresh',
        name: 'refresh',
        meta: {
            title: '跳转页面'
        },
        component: () => import('../views/b2b/common/refresh')
    },
    {
        path: '/b2b/home/index',
        name: 'home',
        meta: {
            title: '首页',
            isUseCache: false,
            isPage: false,
            savedPosition: 0
        },
        component: () => import('../views/b2b/home/index')
    },
    {
        path: '/b2b/initPage/index',
        name: 'initPage',
        meta: {
            title: '初始页面'
        },
        component: () => import('../views/b2b/initPage/index')
    },
    {
        path: '/b2b/specialActivity/index',
        name: 'special',
        meta: {
            title: '专题活动'
        },
        component: () => import('../views/b2b/specialActivity/index')
    },
    {
        path: '/b2b/specialActivity/list',
        name: 'specialList',
        meta: {
            title: '专题活动列表'
        },
        component: () => import('../views/b2b/specialActivity/list')
    },
    {
        path: '/b2b/initPage/create',
        name: 'create',
        meta: {
            title: '创建企业'
        },
        component: () => import('../views/b2b/initPage/create')
    },
    {
        path: '/b2b/company/editCompany',
        name: 'editCompany',
        meta: {
            title: '修改企业'
        },
        component: () => import('../views/b2b/company/editCompany')
    },
    {
        path: '/b2b/staff/index',
        name: 'staff',
        meta: {
            title: '员工管理'
        },
        component: () => import('../views/b2b/staff/index')
    },
    {
        path: '/b2b/company/index',
        name: 'company',
        meta: {
            title: '我的企业'
        },
        component: () => import('../views/b2b/company/index')
    },
    {
        path: '/b2b/accountManage/index',
        name: 'accountManage',
        meta: {
            title: '账号管理'
        },
        component: () => import('../views/b2b/accountManage/index')
    },
    {
        path: '/b2b/accountManage/editName',
        name: 'editName',
        meta: {
            title: '姓名'
        },
        component: () => import('../views/b2b/accountManage/editName')
    },
    {
        path: '/b2b/accountManage/editPhone',
        name: 'editPhone',
        meta: {
            title: '更换手机号'
        },
        component: () => import('../views/b2b/accountManage/editPhone')
    },
    {
        path: '/b2b/accountManage/editPassword',
        name: 'editPassword',
        meta: {
            title: '修改密码'
        },
        component: () => import('../views/b2b/accountManage/editPassword')
    },
    {
        path: '/b2b/payCode/setPayCode',
        name: 'setPayCode',
        meta: {
            title: '设置钱包支付密码'
        },
        component: () => import('../views/b2b/accountManage/payCode/setPayCode')
    },
    {
        path: '/b2b/payCode/editPayCode',
        name: 'editPayCode',
        meta: {
            title: '修改钱包支付密码'
        },
        component: () => import('../views/b2b/accountManage/payCode/editPayCode')
    },
    {
        path: '/b2b/payCode/resetPayCode',
        name: 'resetPayCode',
        meta: {
            title: '重置钱包支付密码'
        },
        component: () => import('../views/b2b/accountManage/payCode/resetPayCode')
    },
    {
        path: '/b2b/address/selectAddress',
        name: 'selectAddress',
        meta: {
            title: '选择地址'
        },
        component: () => import('../views/b2b/address/selectAddress')
    },
    {
        path: '/b2b/home/storey',
        name: 'storey',
        meta: {
            title: '楼层更多'
        },
        component: () => import('../views/b2b/home/storey')
    },
    {
        path: '/b2b/address/addAddress',
        name: 'addAddress',
        meta: {
            title: '添加地址'
        },
        component: () => import('../views/b2b/address/addAddress')
    },
    {
        path: '/b2b/address/editAddress',
        name: 'editAddress',
        meta: {
            title: '编辑地址'
        },
        component: () => import('../views/b2b/address/editAddress')
    },
    {
        path: '/b2b/address/selectDeliveryAddress',
        name: 'selectDeliveryAddress',
        meta: {
            title: '选择提货地址'
        },
        component: () => import('../views/b2b/address/selectDeliveryAddress')
    },
    {
        path: '/b2b/invoice/invoiceList',
        name: 'invoiceList',
        meta: {
            title: '申请发票'
        },
        component: () => import('../views/b2b/invoice/invoiceList')
    },
    {
        path: '/b2b/invoice/invoiceDetail',
        name: 'invoiceDetail',
        meta: {
            title: '申请开票'
        },
        component: () => import('../views/b2b/invoice/invoiceDetail')
    },
    {
        path: '/b2b/invoice/invoiceApplication',
        name: 'invoiceApplication',
        meta: {
            title: '申请开票',
            isUseCaChe: false
        },
        component: () => import('../views/b2b/invoice/invoiceApplication')
    },
    {
        path: '/b2b/order/confirmOrder',
        name: 'confirmOrder',
        meta: {
            title: '确认订单'
        },
        component: () => import('../views/b2b/order/confirmOrder')
    },
    {
        path: '/b2b/goods/goodsList',
        name: 'goodsList',
        meta: {
            title: '商品列表',
            savedPosition: 0
        },
        component: () => import('../views/b2b/goods/goodsList')
    },
    {
        path: '/b2b/goods/goodsDetail',
        name: 'goodsDetail',
        meta: {
            title: '商品详情'
        },
        component: () => import('../views/b2b/goods/goodsDetail')
    },
    {
        path: '/b2b/goods/shareGoods',
        name: 'shareGoods',
        meta: {
            title: '商品分享详情'
        },
        component: () => import('../views/b2b/goods/shareGoods.vue')
    },
    {
        path: '/b2b/goods/allGoods',
        name: 'allGoods',
        meta: {
            isUseCaChe: true,
            title: '全部商品'
        },
        component: () => import('../views/b2b/goods/allGoods')
    },
    {
        path: '/b2b/goods/allGoods2',
        name: 'allGoods2',
        meta: {
            title: '查看更多'
        },
        component: () => import('../views/b2b/goods/allGoods2')
    },
    {
        path: '/b2b/cart/cart',
        name: 'cart',
        meta: {
            title: '购物车',
            isUseCache: false
        },
        component: () => import('../views/b2b/cart/cart')
    },
    {
        path: '/b2b/payment/payResult',
        name: 'payResult',
        meta: {
            title: '支付结果'
        },
        component: () => import('../views/b2b/payment/payResult')
    },
    {
        path: '/b2b/payment/paySuccess',
        name: 'paySuccess',
        meta: {
            title: '支付结果'
        },
        component: () => import('../views/b2b/payment/paySuccess')
    },
    {
        path: '/b2b/payment/transfer',
        name: 'transfer',
        meta: {
            title: '公司转账'
        },
        component: () => import('../views/b2b/payment/transfer')
    },
    {
        path: '/b2b/order/index',
        name: 'order',
        meta: {
            isUseCaChe: false,
            keepAlive: true,
            title: '我的信息'
        },
        component: () => import('../views/b2b/order/index')
    },
    {
        path: '/b2b/order/memberEquity',
        name: 'memberEquity',
        meta: {
            title: '付费会员权益'
        },
        component: () => import('../views/b2b/order/memberEquity')
    },
    {
        path: '/b2b/order/myCollect',
        name: 'myCollect',
        meta: {
            title: '我的收藏'
        },
        component: () => import('../views/b2b/order/myCollect')
    },
    {
        path: '/b2b/order/orderList',
        name: 'orderList',
        meta: {
            title: '我的订单',
            savedPosition: 0
        },
        component: () => import('../views/b2b/order/orderList')
    },
    {
        path: '/b2b/order/orderDetail',
        name: 'orderDetail',
        meta: {
            title: '订单详情'
        },
        component: () => import('../views/b2b/order/orderDetail')
    },
    {
        path: '/b2b/search/index',
        name: 'search',
        meta: {
            title: '搜索'
        },
        component: () => import('../views/b2b/search/index')
    },
    {
        path: '/b2b/search/result',
        name: 'searchResult',
        meta: {
            title: '搜索结果',
            savedPosition: 0
        },
        component: () => import('../views/b2b/search/result')
    },
    // 错误页面
    {
        path: '/b2b/goods/error',
        name: 'error',
        meta: {
            title: '错误页面'
        },
        component: () => import('../views/b2b/goods/error')
    },
    {
        path: '/b2b/wallet/assets',
        name: 'assets',
        meta: {
            title: '我的钱包'
        },
        component: () => import('../views/b2b/wallet/myWallet/assets')
    },
    {
        path: '/b2b/wallet/MyWallet/walletDetails',
        name: 'walletDetails',
        meta: {
            title: '账单'
        },
        component: () => import('../views/b2b/wallet/myWallet/walletDetails')
    },
    {
        path: '/b2b/wallet/MyWallet/activityWalletDetails',
        name: 'activityWalletDetails',
        meta: {
            title: '活动账单'
        },
        component: () => import('../views/b2b/wallet/myWallet/activityWalletDetails')
    },
    {
        path: '/b2b/wallet/MyWallet/cashOut',
        name: 'cashOut',
        meta: {
            title: '钱包提现'
        },
        component: () => import('../views/b2b/wallet/myWallet/cashOut')
    },
    {
        path: '/b2b/wallet/MyWallet/result',
        name: 'cashOut',
        meta: {
            title: '提现结果'
        },
        component: () => import('../views/b2b/wallet/myWallet/result')
    },
    {
        path: '/b2b/wallet/topUps',
        name: 'topUps',
        meta: {
            title: '充值'
        },
        component: () => import('../views/b2b/wallet/myWallet/topUps')
    },
    {
        path: '/b2b/wallet/transferAccount',
        name: 'topUps',
        meta: {
            title: '转账账户'
        },
        component: () => import('../views/b2b/wallet/myWallet/transferAccount')
    },
    {
        path: '/b2b/wallet/topUpsResult',
        name: 'topUpsResult',
        meta: {
            title: '充值结果'
        },
        component: () => import('../views/b2b/wallet/myWallet/topUpsResult')
    },
    {
        path: '/b2b/payment/cashier',
        name: 'cashier',
        meta: {
            title: '收银台'
        },
        component: () => import('../views/b2b/payment/cashier')
    },
    {
        path: '/b2b/order/couponList',
        name: 'couponList',
        meta: {
            title: '我的优惠券'
        },
        component: () => import('../views/b2b/order/couponList')
    },
    {
        path: '/b2b/order/selectEffect',
        name: 'selectEffect',
        meta: {
            title: '选择优惠券'
        },
        component: () => import('../views/b2b/order/selectEffect')
    },
    {
        path: '/b2b/home/effect',
        name: 'effect',
        meta: {
            title: '优惠券'
        },
        component: () => import('../views/b2b/home/effect')
    },
    {
        path: '/b2b/conceal/index',
        name: 'conceal',
        meta: {
            title: '隐私政策'
        },
        component: () => import('../views/b2b/conceal/index')
    },
    {
        path: '/b2b/home/more',
        name: 'more',
        meta: {
            title: '爆款推荐'
        },
        component: () => import('../views/b2b/home/more')
    },
    {
        path: '/b2b/home/effectList',
        name: 'effectList',
        meta: {
            title: '领券购物'
        },
        component: () => import('../views/b2b/home/effectList')
    },
    {
        path: '/b2b/questionnaire',
        name: 'questionnaire',
        meta: {
            title: '会员经营问卷调研'
        },
        component: () => import('../views/b2b/questionnaire')
    },
    {
        path: '*',
        component: () => import('../views/b2b/home/error')
    },
    {
        path: '/b2b/drainageRegiste/activeShare',
        name: 'drainageRegiste',
        meta: {
            title: '活动分享'
        },
        component: () => import('../views/b2b/drainageRegiste/activeShare')
    },
    {
        path: '/b2b/drainageRegiste/regist',
        name: 'regist',
        meta: {
            title: '注册'
        },
        component: () => import('../views/b2b/drainageRegiste/regist')
    },
    {
        path: '/b2b/server/index',
        name: 'server2',
        meta: {
            title: '服务协议'
        },
        component: () => import('../views/b2b/server/index')
    },
    {
        path: '/b2b/server/memberServer',
        name: 'memberServer',
        meta: {
            title: '会员服务协议'
        },
        component: () => import('../views/b2b/server/memberServer')
    },
    {
        path: '/b2b/server/registerServer',
        name: 'registerServer',
        meta: {
            title: '用户注册协议'
        },
        component: () => import('../views/b2b/server/registerServer')
    },
    {
        path: '/b2b/server/salesServer',
        name: 'salesServer',
        meta: {
            title: '售后规则'
        },
        component: () => import('../views/b2b/server/salesServer')
    },
    {
        path: '/b2b/drainageRegiste/registerSuccess',
        name: 'registerSuccess',
        meta: {
            title: '注册成功'
        },
        component: () => import('../views/b2b/drainageRegiste/registerSuccess')
    },
    {
        path: '/b2b/member/index',
        name: 'member',
        meta: {
            title: '我的好友推荐'
        },
        component: () => import('../views/b2b/member/index')
    },
    {
        path: '/b2b/companyActivity/confirmOrder',
        name: 'activityOrder',
        meta: {
            title: '活动下单页'
        },
        component: () => import('../views/b2b/companyActivity/confirmOrder')
    },
    {
        path: '/b2b/companyActivity/goodsDetail',
        name: 'activityDetail',
        meta: {
            title: '活动商品详情'
        },
        component: () => import('../views/b2b/companyActivity/goodsDetail')
    },
    {
        path: '/b2b/companyActivity/shareGoods',
        name: 'shareGoods',
        meta: {
            title: '活动商品详情分享'
        },
        component: () => import('../views/b2b/companyActivity/shareGoods')
    },
    {
        path: '/b2b/companyActivity/specialZone',
        name: 'specialZone',
        meta: {
            title: '秒杀专区'
        },
        component: () => import('../views/b2b/companyActivity/specialZone')
    },
    {
        path: '/b2b/groupBookActivity/groupBookList',
        name: 'groupBookList',
        meta: {
            title: '拼团专区'
        },
        component: () => import('../views/b2b/groupBookActivity/groupBookList')
    },
    {
        path: '/b2b/order/addBank',
        name: 'addBank',
        meta: {
            title: '添加银行卡'
        },
        component: () => import('../views/b2b/order/addBank')
    },
    {
        path: '/b2b/order/result',
        name: 'editBankResult',
        meta: {
            title: '添加银行卡结果页'
        },
        component: () => import('../views/b2b/order/result')
    },
    {
        path: '/b2b/business/open',
        name: 'business',
        meta: {
            title: '上传证件'
        },
        component: () => import('../views/b2b/businessOpen/certificates')
    },
    {
        path: '/b2b/business/openStatus',
        name: 'openStatus',
        meta: {
            title: '实名开户'
        },
        component: () => import('../views/b2b/businessOpen/openCertificates')
    },
    {
        path: '/b2b/business/approveResult',
        name: 'approveResult',
        meta: {
            title: '认证结果'
        },
        component: () => import('../views/b2b/businessOpen/approveResult')
    },
    {
        path: '/b2b/business/openResult',
        name: 'openResult',
        meta: {
            title: '开户结果'
        },
        component: () => import('../views/b2b/businessOpen/openResult')
    },
    {
        path: '/b2b/business/errorResult',
        name: 'errorResult',
        meta: {
            title: '开户结果'
        },
        component: () => import('../views/b2b/businessOpen/errorResult')
    },
    {
        path: '/b2b/downdfx',
        name: 'downdfx',
        meta: {
            title: '单分享下载'
        },
        component: () => import('../views/common/downDfx')
    },
    {
        path: '/b2b/downdfx2',
        name: 'downdfx2',
        meta: {
            title: '单分享下载'
        },
        component: () => import('../views/common/downDfx2')
    },
    {
        path: '/b2b/order/myBank',
        name: 'myBank',
        meta: {
            title: '银行卡'
        },
        component: () => import('../views/b2b/order/myBank')
    },
    {
        path: '/b2b/payment/accountPay',
        name: 'accountPay',
        meta: {
            title: '账期支付'
        },
        component: () => import('../views/b2b/payment/accountPay')
    },
    {
        path: '/b2b/groupBookActivity/groupDetail',
        name: 'groupDetail',
        meta: {
            title: '拼团详情'
        },
        component: () => import('../views/b2b/groupBookActivity/groupDetail')
    },
    {
        path: '/b2b/groupBookActivity/goodsDetail',
        name: 'groupBookDetail',
        meta: {
            title: '拼团商品详情'
        },
        component: () => import('../views/b2b/groupBookActivity/goodsDetail')
    },
    {
        path: '/b2b/common/runArea',
        name: 'runArea',
        meta: {
            title: '设置经营区域'
        },
        component: () => import('../views/b2b/common/runArea')
    },
    {
        path: '/b2b/logistics/index',
        name: 'logistics',
        meta: {
            title: '物流详情'
        },
        component: () => import('../views/b2b/logistics/index')
    },
    {
        path: '/b2b/inquiry/inquirySubmit',
        name: 'enquiryAdd',
        meta: {
            title: '提交询价单'
        },
        component: () => import('../views/b2b/inquiry/inquirySubmit')
    },
    {
        path: '/b2b/inquiry/inquiryFeedback',
        name: 'addResult',
        meta: {
            title: '提交结果页'
        },
        component: () => import('../views/b2b/inquiry/inquiryFeedback')
    },
    {
        path: '/b2b/inquiry/inquiryDetail',
        name: 'enquiryDetail',
        meta: {
            title: '询价单详情'
        },
        component: () => import('../views/b2b/inquiry/inquiryDetail')
    },
    {
        path: '/b2b/inquiry/inquiryList',
        name: 'enquiryList',
        meta: {
            title: '询价单列表'
        },
        component: () => import('../views/b2b/inquiry/inquiryList')
    },
    {
        path: '/b2b/inquiry/inquirySkus',
        name: 'enquirySelect',
        meta: {
            title: '已选定商品'
        },
        component: () => import('../views/b2b/inquiry/inquirySkus')
    },
    {
        path: '/b2b/wallet/activityAssets',
        name: 'activityAssets',
        meta: {
            title: '活动预充'
        },
        component: () => import('../views/b2b/wallet/myWallet/activityAssets')
    },
    {
        path: '/b2b/429',
        name: '限流',
        meta: {
            title: '单分享'
        },
        component: () => import('../views/b2b/common/429')
    },
    {
        path: '/b2b/server/precharge',
        name: 'precharge',
        meta: {
            title: '充值协议'
        },
        component: () => import('../views/b2b/server/precharge')
    },
    {
        path: '/b2b/wallet/applyResult',
        name: 'applyResult',
        meta: {
            title: '申请结果'
        },
        component: () => import('../views/b2b/wallet/myWallet/applyResult')
    },
    // 组合go活动列表
    {
        path: '/b2b/groupActivity/groupActivityList',
        name: 'groupActivityList',
        meta: {
            title: '组合go活动列表'
        },
        component: () => import('../views/b2b/groupActivity/groupActivityList')
    },
    // 组合go活动购物车
    {
        path: '/b2b/groupActivity/groupActivityCart',
        name: 'groupActivityCart',
        meta: {
            title: '选择您的组合'
        },
        component: () => import('../views/b2b/groupActivity/groupActivityCart')
    },
    // 预售活动列表
    {
        path: '/b2b/presellActivityList/index',
        name: 'presellActivityList',
        meta: {
            title: '预售专区'
        },
        component: () => import('../views/b2b/presellActivityList/index')
    },
    // 预售活动详情页
    {
        path: '/b2b/presellActivityList/goodDetail',
        name: 'presellActivityGoodDetail',
        meta: {
            title: '商品详情'
        },
        component: () => import('../views/b2b/presellActivityList/goodDetail')
    },
    // 预售订单列表
    {
        path: '/b2b/presellActivityList/presellOrderList',
        name: 'presellOrderList',
        meta: {
            title: '预售订单'
        },
        component: () => import('../views/b2b/presellActivityList/presellOrderList')
    },
    // 预售服务协议
    {
        path: '/b2b/server/presellServer',
        name: 'presellServer',
        meta: {
            title: '单分享平台预售业务管理规范'
        },
        component: () => import('../views/b2b/server/presellServer')
    },
    // 运费明细
    {
        path: '/b2b/order/freightDetails',
        name: 'freightDetails',
        meta: {
            title: '运费明细'
        },
        component: () => import('../views/b2b/order/freightDetails')
    },
    // 应返明细
    {
        path: '/b2b/repay/repayDetail',
        name: 'repayDetail',
        meta: {
            title: '应返明细'
        },
        component: () => import('../views/b2b/repay/repayDetail')
    },
    // 满返余额
    {
        path: '/b2b/repay/repayBalance',
        name: 'repayBalance',
        meta: {
            title: '满返余额'
        },
        component: () => import('../views/b2b/repay/repayBalance')
    },
    // 账单
    {
        path: '/b2b/repay/repayBill',
        name: 'repayBill',
        meta: {
            title: '账单'
        },
        component: () => import('../views/b2b/repay/repayBill')
    },
    // 退款/售后列表
    {
        path: '/b2b/refundOrder/index',
        name: 'refundList',
        meta: {
            title: '退款列表',
            savedPosition: 0
        },
        component: () => import('../views/b2b/refundOrder/index')
    },
    // 售后详情
    {
        path: '/b2b/refundOrder/detail',
        name: 'refundDetail',
        meta: {
            title: '售后详情'
        },
        component: () => import('../views/b2b/refundOrder/detail')
    },
    // 选择服务
    {
        path: '/b2b/refundOrder/selectServer',
        name: 'selectServer',
        meta: {
            title: '选择服务'
        },
        component: () => import('../views/b2b/refundOrder/selectServer')
    },
    // 申请退款
    {
        path: '/b2b/refundOrder/applyRefund',
        name: 'applyRefund',
        meta: {
            title: '申请退款'
        },
        component: () => import('../views/b2b/refundOrder/applyRefund')
    },
    // 申请退款
    {
        path: '/b2b/refundOrder/refundAmount',
        name: 'refundAmount',
        meta: {
            title: '申请退款'
        },
        component: () => import('../views/b2b/refundOrder/refundAmount')
    },
    // 选择退款商品
    {
        path: '/b2b/refundOrder/selectRefund',
        name: 'selectRefund',
        meta: {
            title: '选择退款商品'
        },
        component: () => import('../views/b2b/refundOrder/selectRefund')
    },
    // 资料库列表页面
    {
        path: '/b2b/specialActivity/dataBank',
        name: 'dataBank',
        meta: {
            title: '资料库'
        },
        component: () => import('../views/b2b/specialActivity/dataBank')
    }
]
